<template>
    <div>
        <div class="success-box spaceCenter text-color-black"><a-icon type="check-circle" />{{text}}</div>
    </div>
</template>

<script>
export default {
    name:"success",
    props:["text"],
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    methods: {},
    created() {},
    mounted() {},
    beforeCreate() {},
    beforeMount() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    activated() {},
    watch: {},
}
</script>
<style scoped>
    .success-box{
        font-size: 20px;
        margin: 50px auto;
    }
    .success-box i{
        color:#61c86f;
        margin-right: 10px;
        font-size: 28px;
    }
</style>


// WEBPACK FOOTER //
// src/components/steps/success.vue